import { fetchReducer } from 'iqvia-shared';
import reduceReducers from 'reduce-reducers';

import apiNameEnums from '../../../Enums/apiNames';

const defaultState = {
  isLoading: false,
  value: [], //added as init value to prevent cannot read properties error
};

const metrics = (state = defaultState, { type }) => {
  switch (type) {
    default:
      return state;
  }
};

export default reduceReducers(metrics, fetchReducer(apiNameEnums.GET_METRICS));



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/reducers/metrics.js